import { type BadgeProps } from "@/components/ui/badge";
import { APP_MODE } from "@/integrations/supabase/supabaseConfig";

export interface EnvironmentBadgeConfig {
  isVisible: boolean;
  label: string;
  variant: BadgeProps["variant"];
}

export function getEnvironmentBadge(
  mode: string = APP_MODE,
): EnvironmentBadgeConfig {
  if (mode === "preview") {
    return {
      isVisible: true,
      label: "Preview",
      variant: "warning",
    };
  }

  return {
    isVisible: false,
    label: "",
    variant: "secondary",
  };
}
